import { createContext } from 'react';

import { TSmartWalletContextValues } from './SmartWalletContext.interface';

const defaultValues: TSmartWalletContextValues = {
  smartAccountAddress: undefined,
  isLoadingSafeWallet: false,
  pimlicoClient: undefined,
  publicClient: undefined,
  smartAccountClient: undefined,
  isLoading: false,
  isConnected: false,
  isLoggedIn: false,
  getSmartAccountClient: () => {},
  setSmartAccountAddress: () => {},
  logout: () => {},
  login: () => {},
};

export const WalletProviderContext =
  createContext<TSmartWalletContextValues>(defaultValues);
